<table class="{{ tableType }}">
  <thead
    class="{{ tableType }}__header"
    [class.employee__trash]="showTrashIcon"
  >
    <tr class="{{ tableType }}__row">
      <th
        *ngFor="let header of tableData.headers"
        class="{{ tableType }}__header-item"
        [class.no-pointer]="!isSortTable || tableData.data.length < 2"
        (click)="sortData($event, header)"
        [class.material__select]="
          (tableType === 'material' && header.key === 'selected') ||
          header.type === columnTypes.link
        "
      >
        <span [class.dynamic]="header.dynamicColumn">{{
          header.displayedName || (header.key | camelCase)
        }}</span>
      </th>
    </tr>
  </thead>

  <tbody
    class="{{ tableType }}__body"
    *ngIf="tableType !== 'accountant-table-employee'"
  >
    <ng-container
      *ngFor="
        let item of tableData.data | sortTable : columnChecked : type;
        let i = index
      "
    >
      <tr
        class="{{ tableType }}__row"
        [class.employee__row_current]="
          item?.status === 'Current' && tableType === 'employee'
        "
        [class.employee__row_former]="
          item?.status === 'Former' && tableType === 'employee'
        "
        [class.employee__row_pending]="
          item?.status === 'Pending' && tableType === 'employee'
        "
        [class.novisible]="displayOnlyFirstRow && i > 0"
        [class.tr_cursor]="
          tableType === 'employee' ||
          tableType === 'interview' ||
          isEmitItemFromTable
        "
        [class.cancelled-row]="item.isCancelled"
        (click)="displayAdditionalInfo(i)"
      >
        <td
          *ngIf="tableType == 'accountant-table'"
          class="{{ tableType }}__body_column"
        >
          {{ i + 1 }}
        </td>
        <ng-container *ngFor="let column of tableData.headers">
          <td
            class="{{ tableType }}__body-item"
            [class.align-top]="column.dynamicColumn"
            [class.material__checkbox]="
              (tableType === 'material' && column.key === 'selected') ||
              column.type === columnTypes.link
            "
            [class.red_hr]="item[column.key]?.name === 'Low'"
            [class.yellow_hr]="item[column.key]?.name === 'Average'"
            [class.detailed-salary-active]="i === clickedIndex"
            [class.green_hr]="item[column.key]?.name === 'Good'"
            (click)="
              tableType === 'interview' || isEmitItemFromTable
                ? emitterItem.emit(item)
                : tableType === 'employee'
                ? emitterId.emit(item.id)
                : null
            "
          >
            <ng-container [ngSwitch]="column.type">
              <ng-container *ngSwitchCase="columnTypes.datePicker">
                <div class="table__item">
                  {{ item[column.key] }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypes.topicComment">
                <div class="topic-comment">
                  {{ item[column.key] }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypes.topicTable">
                <ng-container *ngIf="item[column.key]">
                  <table class="topic-table">
                    <tr>
                      <td class="topic-td">Status</td>
                      <td class="topic-td">{{ item[column.key].status }}</td>
                    </tr>
                    <tr>
                      <td class="topic-td">Important</td>
                      <td class="topic-td">
                        {{ item[column.key].important }}
                      </td>
                    </tr>
                    <tr>
                      <td class="topic-td">Satisfaction</td>
                      <td class="topic-td">
                        {{ item[column.key].satisfaction }}
                      </td>
                    </tr>
                  </table>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="columnTypes.checkBox">
                <input
                  (change)="
                    onClickTableCell(
                      $event,
                      item.id,
                      item[column.key],
                      'selectId',
                      tableData.data
                    )
                  "
                  class="{{ tableType }}__item-checkbox"
                  type="checkbox"
                  [(ngModel)]="item[column.key]"
                  *ngIf="tableType == 'accountant-table' || 'material'"
                />
              </ng-container>

              <ng-container *ngSwitchCase="columnTypes.dropDown">
                <div class="table__item">
                  {{ item[column.key] | dropdownObject : 'name' }}
                </div>
              </ng-container>
              <ng-container
                *ngSwitchCase="columnTypes.editable"
                [formGroup]="editableTableForm"
              >
                <fieldset [disabled]="!showEditFields" class="form__fieldset">
                  <input
                    type="number"
                    class="editable-field"
                    [formControlName]="column.key"
                    [class.eroor-border]="
                      editableTableForm.controls[column.key].invalid
                    "
                    [class.editable]="
                      showEditFields && !disabledColumnData.includes(column.key)
                    "
                  />
                </fieldset>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypes.topics">
                <div class="topics">
                  <ng-container *ngIf="item[column.key].length; else notopics">
                    <div class="topics__more button button__lightblue">
                      <a (click)="rowClick($event, i, 'topic')"
                        >Topics information
                      </a>
                    </div>
                  </ng-container>
                  <ng-template #notopics> No topics </ng-template>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypes.link">
                <img
                  *ngIf="!item[column.key]"
                  class="interview__empty_doc icon"
                  src="assets/icons/svg/attach_document/none.svg"
                  alt="link-empty"
                />
                <a [href]="item.file" target="_blank">
                  <img
                    *ngIf="item[column.key]"
                    class="interview__attached_doc icon"
                    src="assets/icons/svg/attached_document/normal.svg"
                    alt="link"
                  />
                </a>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <span
                  class="content"
                  [class.clickable]="column.clickable"
                  [class.dynamic]="column.dynamicColumn"
                  (click)="
                    column.clickable &&
                      onClickTableCell(
                        $event,
                        item.id,
                        item[column.key],
                        'detail-view'
                      )
                  "
                >
                  <ng-container
                    *ngIf="
                      (item[column.key] | typeof) === 'number';
                      else notANumber
                    "
                  >
                    {{ item[column.key] | number : '1.0-2' }}
                  </ng-container>
                  <ng-template #notANumber>
                    {{ item[column.key] }}
                  </ng-template>
                </span>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <ng-container *ngIf="editMenu === 'icon' && showEditFields">
          <ng-container
            *ngIf="editOnlyLastRow && i === tableData.data.length - 1"
          >
            <i class="icon-pencil" (click)="rowClick($event, i, 'edit')"></i>
          </ng-container>
          <ng-container *ngIf="!editOnlyLastRow && !editLastTwoRows">
            <i class="icon-pencil" (click)="rowClick($event, i, 'edit')"></i>
          </ng-container>
          <ng-container
            *ngIf="
              editLastTwoRows &&
              (i === tableData.data.length - 1 ||
                i === tableData.data.length - 2)
            "
          >
            <i class="icon-pencil" (click)="rowClick($event, i, 'edit')"></i>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showTrashIcon">
          <td class="trash-without-edit">
            <img
              class=""
              src="assets/icons/svg/trash/ion_trash-bin.svg"
              alt="trash"
              (click)="rowClick($event, i, 'delete')"
            />
          </td>
        </ng-container>
        <ng-container
          *ngIf="
            deleteOnlyLastRow &&
            showEditFields &&
            i === tableData.data.length - 1
          "
        >
          <td class="trash">
            <img
              class=""
              src="assets/icons/svg/trash/ion_trash-bin.svg"
              alt="trash"
              (click)="rowClick($event, i, 'delete')"
            />
          </td>
        </ng-container>
      </tr>
      <ng-container *ngIf="i === clickedIndex && tableType === 'salary-table'">
        <tr class="material__row">
          <div class="detailed-salary">
            <tr>
              <td
                *ngFor="let detailedHeader of additionalHeaders"
                class="detailed-salary__header-item"
              >
                {{
                  detailedHeader.displayedName ||
                    (detailedHeader.key | camelCase)
                }}
              </td>
            </tr>
            <tr>
              <td
                class="material__body-item"
                *ngFor="let header of additionalHeaders"
              >
                <ng-container
                  *ngIf="
                    (item[header.key] | typeof) === 'number';
                    else notANumber
                  "
                >
                  {{ item[header.key] | number : '1.0-2' }}
                </ng-container>
                <ng-template #notANumber>
                  {{ item[header.key] }}
                </ng-template>
              </td>
            </tr>
          </div>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="
        tableType === 'salary-table' ||
        tableType === 'accountant-table' ||
        tableType === 'accountant-table-client'
      "
    >
      <ng-container *ngIf="total">
        <tr class="salary-table__total_row">
          <td class="salary-table__total_title">Total sum</td>
          <ng-container *ngFor="let header of tableData.headers">
            <td
              *ngIf="
                total[header.key] !== undefined &&
                  total[header.key] !== 'Total';
                else empty_td
              "
              class="salary-table__total_items"
            >
              {{ total[header.key] | number : '1.0-2' }}
            </td>

            <ng-template #empty_td>
              <td class="salary-table__total_items"></td>
            </ng-template>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="tableType === 'system-logs'">
      <ng-container
        *ngFor="let monthItem of tableData.data; let monthIndex = index"
      >
        <tr class="system-logs__month-row">
          <td>{{ monthItem.month }}</td>
        </tr>
        <tr
          class="system-logs__change-row"
          *ngFor="let changeRow of monthItem.data; let itemIndex = index"
        >
          <ng-container *ngFor="let header of tableData.headers">
            <ng-container [ngSwitch]="header.type">
              <ng-container *ngSwitchCase="columnTypes.dateUTC">
                <td class="system-logs__change-item">
                  {{ changeRow[header.key] | date : 'dd.MM.yyyy HH:mm' }}
                </td>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypes.valueDisplay">
                <td
                  class="system-logs__change-item"
                  *ngIf="
                    changeRow['actionType'] === 'Update' &&
                      changeRow.newValues &&
                      changeRow.oldValues;
                    else notupdate
                  "
                >
                  <div
                    class="topics__more button button__lightblue"
                    (click)="rowClick($event, monthIndex, 'values', itemIndex)"
                  >
                    <a>Changes information </a>
                  </div>
                </td>
                <ng-template #notupdate>
                  <td></td>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <td class="system-logs__change-item">
                  {{ changeRow[header.key] }}
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
  <ng-container *ngIf="tableType === 'accountant-table-employee'">
    <ng-container
      *ngFor="let monthItem of tableData.data; let monthIndex = index"
    >
      <div class="accountant-table-employee__month-row">
        {{ monthItem.month }}
      </div>
      <tbody class="{{ tableType }}__body">
        <tr
          class="{{ tableType }}__row"
          *ngFor="
            let changeRow of monthItem.listDetailInfo
              | sortTable : columnChecked : type;
            let itemIndex = index
          "
        >
          <td class="{{ tableType }}__body_column">
            {{ itemIndex + 1 }}
          </td>
          <ng-container *ngFor="let header of tableData.headers">
            <td class="{{ tableType }}__body-item">
              <span
                class="content"
                [class.clickable]="header.clickable"
                (click)="
                  header.clickable &&
                    onClickTableCell(
                      $event,
                      changeRow.id,
                      changeRow[header.key],
                      'detail-view'
                    )
                "
              >
                <ng-container
                  *ngIf="
                    (changeRow[header.key] | typeof) === 'number';
                    else notANumber
                  "
                >
                  {{ changeRow[header.key] | number : '1.0-2' }}
                </ng-container>
                <ng-template #notANumber>
                  {{ changeRow[header.key] }}
                </ng-template>
              </span>
            </td>
          </ng-container>
        </tr>
        <ng-container>
          <tr class="salary-table__total_row">
            <td class="salary-table__total_title">Total sum</td>
            <ng-container *ngFor="let header of tableData.headers">
              <td
                *ngIf="
                  monthItem.listDetailInfoTotal[header.key] !== undefined &&
                    monthItem.listDetailInfoTotal[header.key] !== 'Total';
                  else empty_td
                "
                class="salary-table__total_items"
              >
                {{
                  monthItem.listDetailInfoTotal[header.key] | number : '1.0-2'
                }}
              </td>
              <ng-template #empty_td>
                <td class="salary-table__total_items"></td>
              </ng-template>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </ng-container>
  </ng-container>

  <button
    *ngIf="displayPlusButton"
    class="button button__add--normal table__btn"
    type="button"
    (click)="rowClick($event, 0, 'add')"
  ></button>
</table>

<div class="table__pagination" *ngIf="tableType === 'system-logs'">
  <app-pagination
    [total]="count"
    [setTheFirstPage]="setFirstPage"
    [formControl]="paginationControl"
  ></app-pagination>
</div>
